<script>
  import MenuToggle from './MenuToggle/MenuToggle.svelte';
  import Drawer from '../Drawer/Drawer.svelte';
  import NavList from '../NavList/NavList.svelte';

  export let data = {};
  export let mobileMode;
</script>

<Drawer toggle={MenuToggle}>
  {#if mobileMode}
    {#if data.primaryNavItems}
      <NavList navItems={data.primaryNavItems} />
    {/if}
    {#if data.secondaryNavItems}
      <NavList navItems={data.secondaryNavItems} />
    {/if}
  {/if}
</Drawer>
